var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.isLoading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_c('div',[(_vm.networkData)?_c('div',[_c('VisNetworkBubble',{attrs:{"data":_vm.networkData,"target":_vm.total},on:{"click":_vm.nodeClicked}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }